import { c as _c } from "react/compiler-runtime";
import { DocumentWhite } from "@/lib/icons";
import type { Cat } from "@/types/movies";
import Link from "next/link";
interface Props {
  rating?: string;
  seasons?: string;
  year?: string;
  countries?: Cat[];
  subtitles?: string;
  ageLimit?: string;
}
export default function MovieMeta(props) {
  const $ = _c(24);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="text-[12px] md:text-md font-extrabold text-imdb me-1 md:me-2">IMDB</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.rating) {
    t1 = <div className="flex items-center justify-center">{t0} <span className="sm:text-sm md:text-md font-extrabold text-white">{props.rating}</span></div>;
    $[1] = props.rating;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.seasons) {
    t2 = <span className="sm:text-sm md:text-md text-white">{props.seasons}</span>;
    $[3] = props.seasons;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.year) {
    t3 = <span className="text-[12px] md:text-md text-white font-extrabold me-1 md:me-2">{props.year}</span>;
    $[5] = props.year;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props.countries) {
    t4 = props.countries ?? [];
    $[7] = props.countries;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = t4.map(_temp);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="flex items-center justify-center">{t3}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== props.subtitles) {
    t7 = props?.subtitles && <div className="flex items-center justify-center"><DocumentWhite /><span className="text-[12px] md:text-md text-white font-extrabold ms-1 md:ms-2 mt-1">{props.subtitles}</span></div>;
    $[14] = props.subtitles;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== props.ageLimit) {
    t8 = <span className="text-[12px] md:text-md text-white font-extrabold">{props.ageLimit}</span>;
    $[16] = props.ageLimit;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <div className="mt-4 flex flex-wrap items-center gap-x-2 md:gap-x-5 gap-y-2 text-xs text-[12px] sm:mb-4 md:mb-6">{t1}{t2}{t6}{t7}{t8}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
function _temp(n, idx, arr) {
  const isLast = idx === arr.length - 1;
  return <Link key={idx} href={`/movie/tags/${n.name_en}`} className="text-[12px] md:text-md text-white">{n.name_fa}{!isLast && <span className="mx-1">،</span>}</Link>;
}